export enum FilePurpose {
  IMG = 'IMG',

  VIDEO = 'VIDEO',

  GEODETIC = 'GEODETIC',

  DRAWING = 'DRAWING',

  OTHER = 'OTHER',
}
